import { useQuery } from '@tanstack/react-query';
import { getSurveyJsQuiz } from '~/pages/api/quizzes';

export function getQuizKey(quizid: number) {
   return ['get-quiz', quizid];
}

export function useQuiz(
   quizid: number,
   includeAnswers: boolean = false,
   defaultOrder: boolean = false,
   quizRevisionid: number | null = null
) {
   const queryFunction = async () => {
      return await getSurveyJsQuiz(quizid, includeAnswers, defaultOrder, quizRevisionid);
   };

   return useQuery({
      queryFn: queryFunction,
      queryKey: getQuizKey(quizid),
      refetchOnWindowFocus: false,
   });
}
